import { Currencies } from "@orbital/games-frontend-library"

export const helperBetAmount = (
  e: any,
  currency: string,
  setbetAmount: any,
) => {
  let str = e.target.value.slice(
    Currencies[currency].length,
    e.target.value.length,
  )
  let regex = /^\d*\.?\d*$/
  let test = regex.test(str)
  if (test) {
    return setbetAmount(Currencies[currency] + str)
  }
}

export const helperNumOfBet = (e: any, setnumOfBets: any) => {
  let str = e.target.value
  let regex = /^[0-9]*$/
  let test = regex.test(str)
  //    str = str !== '0' && str !== '' ? str : ''
  if (str === "0") str = ""
  if (test) {
    return setnumOfBets(str)
  }
}

export const helperCashoutAt = (
  e: any,
  currency: string,
  setcashoutAt: any,
) => {
  let str = e.target.value.slice(
    Currencies[currency].length,
    e.target.value.length,
  )

  // const value = e.target.value
  // if (checkRegEx(value, regexes.numbersDotComma)) {
  //   setStakeValue(value.replace(/,/g, "."))
  // }

  let regex = /^[0-9]*[,.]?[0-9]*$/
  let test = regex.test(str)
  if (test) {
    setcashoutAt(Currencies[currency] + str)
  }
}
